import React from "react";
import { useOrgOptions } from "../../../components/Hooks/classDetailMultiDropdownHook";
import SearchableSingleSelectDropdown from "../../../components/DynamicDropdowns/SearchableSingleSelectDropdown";
import { useDebouncedSearch } from "../../../utils/constants/app-constants";

interface CollabProps {
  setCollabOrganisation: (orgType: CourseOption) => void;
  collabOrganisation?: CourseOption;
}
interface CourseOption {
  label: string;
  value: string;
}

const OrganisationFilter: React.FC<CollabProps> = ({
  setCollabOrganisation,
  collabOrganisation
}) => {
  const { options: organisationList, isUploadloading: orgListLoading, fetchOrganisation } = useOrgOptions(1);
  const debouncedSearchOrganisation = useDebouncedSearch(fetchOrganisation)

  const dropdownOptions = React.useMemo(() => {
    if (!collabOrganisation?.label) return organisationList;
    const exists = organisationList.some(
      (opt: CourseOption) => opt.value === collabOrganisation.value
    );
    return exists
      ? organisationList
      : [collabOrganisation, ...organisationList];
  }, [organisationList, collabOrganisation]);

  return (
    <SearchableSingleSelectDropdown
      dropdownLabel="Organization"
      mainId="organisationFilter"
      placeHolder="All organizations"
      data-testid="org-filter-id"
      dropId="Organization"
      data={dropdownOptions.map((v:any) => v.label)}
      listInBtn
      isLoading={orgListLoading}
      required={false}
      value={collabOrganisation?.label ?? ""} 
      onSearch={debouncedSearchOrganisation}
      onChange={(value: string) => {
        const selectedOption = dropdownOptions.find(
          (option: CourseOption) => option.label === value
        );
        setCollabOrganisation(
          selectedOption ?? { label: "", value: "" }
        );
      }}
    />
  );
};

export default OrganisationFilter;
